import { apiClient, APIResponse, extractApiError } from './api';


export const aiAPI = {
  async getContext(pageId) {
    try {
      const { data } = await apiClient.get('/ai/context/', {
        params: { page: pageId },
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível carregar o assistente.'));
    }
  },

  async listSessions() {
    try {
      const { data } = await apiClient.get('/ai/sessions/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível carregar o histórico.'));
    }
  },

  async getSession(sessionId) {
    try {
      const { data } = await apiClient.get(`/ai/sessions/${sessionId}/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(extractApiError(error, 'Não foi possível carregar a conversa.'));
    }
  },

  async chat({ pageId, message, history = [], sessionId = null }) {
    try {
      const payload = {
        page_id: pageId,
        message,
      };
      if (sessionId) {
        payload.session_id = sessionId;
      } else if (history.length) {
        payload.history = history;
      }

      const { data } = await apiClient.post('/ai/chat/', payload);
      return APIResponse.success(data);
    } catch (error) {
      const status = error?.response?.status;
      const responsePayload = error?.response?.data;
      if (status === 429) {
        return APIResponse.error({
          message: responsePayload?.detail || 'Limite diário atingido.',
          rateLimited: true,
        });
      }
      return APIResponse.error(extractApiError(error, 'Não foi possível obter resposta.'));
    }
  },
};
